import { memo } from './basler-components.es776.js';

const supportsScrollTimeline = /* @__PURE__ */ memo(() => window.ScrollTimeline !== undefined);

export { supportsScrollTimeline };
